// extracted by mini-css-extract-plugin
export default {"box":"DeleteBox_box__N1lv8","overlay":"DeleteBox_overlay__RQyND","deleteBox":"DeleteBox_deleteBox__usoM2","progress":"DeleteBox_progress__8w96d"};